import { ColumnDef } from '@tanstack/react-table'

interface FlattenedWheelSetting {
	id: string
	color: string
	title: string
	amount: number
	probability: number
	type?: string
	luckyWheelId: string
	isActive: boolean
	expiredIn: string
}

export const columns: ColumnDef<FlattenedWheelSetting>[] = [
	{
		accessorKey: 'title',
		header: 'ชื่อกงล้อ',
	},
	{
		accessorKey: 'amount',
		header: 'จำนวนรางวัล',
	},
	{
		accessorKey: 'color',
		header: 'สีรางวัล',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<div
					className="h-4 w-4 rounded-full"
					style={{ backgroundColor: row.original.color }}
				/>
				{row.original.color}
			</div>
		),
	},
	{
		accessorKey: 'probability',
		header: 'เปอร์เซ็นต์ในการออกรางวัล',
		cell: ({ row }) => `${(row.original.probability * 100).toFixed(0)}%`,
	},
]
